<script lang="ts" setup>
const { t: $t } = useI18n()

import type { ApiMachineryPublicBaseSelect } from '~/layers/customer-module/types'

const props = defineProps<{ machinery?: ApiMachineryPublicBaseSelect | null, isLoading?: boolean }>()

const machineryPublicType = computed((): OneDataColumn<{ name: string }>[] => [
  {
    title: $t('customerModule.machinery.details.machinery.type.label'),
    key: 'name',
  },
])

const hasMachineryFiles = computed(() => (
  (props.machinery?.type.documentDataSheetFiles && props.machinery?.type.documentDataSheetFiles.length > 0)
  || (props.machinery?.type.documentManualFiles && props.machinery?.type.documentManualFiles.length > 0)
  || (props.machinery?.type.documentVideoFiles && props.machinery?.type.documentVideoFiles.length > 0)
  || (props.machinery?.type.documentExternalVideoFiles && props.machinery?.type.documentExternalVideoFiles.length > 0)
))

const machineryDocumentationVideos = computed(() => props.machinery ? props.machinery.type.documentVideoFiles.concat(props.machinery.type.documentExternalVideoFiles.map(path => ({ path }))) : [])
</script>

<template>
  <CustomerModuleDataCard :title="$t('customerModule.machinery.details.machinery.machineryType')" :is-loading="isLoading" class="text-base">
    <div class="space-y-4">
      <TableOneDataColumn :config="{ data: machinery?.type, columns: machineryPublicType }" />
      <n-divider v-if="hasMachineryFiles" />
      <FileView v-if="machinery?.type.documentDataSheetFiles && machinery?.type.documentDataSheetFiles.length > 0" :label="$t('customerModule.machinery.details.machinery.dataSheet')" :files="machinery?.type.documentDataSheetFiles ?? []" :collapsed-by-default="true" />
      <FileView v-if="machinery?.type.documentManualFiles && machinery?.type.documentManualFiles.length > 0" :label="$t('customerModule.machinery.details.machinery.manual')" :files="machinery?.type.documentManualFiles ?? []" :collapsed-by-default="true" />
      <FileView v-if="machineryDocumentationVideos.length > 0" :label="$t('customerModule.machinery.details.machinery.videos')" :files="machineryDocumentationVideos" :collapsed-by-default="false" />
    </div>
  </CustomerModuleDataCard>
</template>
